// Groups the sources payload (key/label/resource_type) for the source dropdown.
// Known types render in the site's canonical order; unknown ones append
// alphabetically so a future source still shows up without a component change.

const TYPE_ORDER = ['Paper', 'Book', 'Video', 'Course', 'Podcast', 'CodeNotebook', 'Policy']

const TYPE_LABELS = {
    Paper: 'Papers',
    Book: 'Books',
    Video: 'Videos',
    Course: 'Courses',
    Podcast: 'Podcasts',
    CodeNotebook: 'Code Notebooks',
    Policy: 'Policies',
}

export const groupSources = (sources) => {
    const byType = new Map()
    sources.forEach(source => {
        if (!byType.has(source.resource_type)) byType.set(source.resource_type, [])
        byType.get(source.resource_type).push(source)
    })
    const known = TYPE_ORDER.filter(type => byType.has(type))
    const unknown = [...byType.keys()].filter(type => !TYPE_ORDER.includes(type)).sort()
    return [...known, ...unknown].map(type => ({
        type,
        label: TYPE_LABELS[type] || type,
        sources: byType.get(type),
    }))
}
